var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allowedToShow)?_c('div',{staticClass:"request-decline-approve-table-cell"},[_c('span',{staticClass:"buttons"},[_c('span',{staticClass:"button decline",on:{"click":_vm.decline}},[_vm._v(_vm._s(_vm.$t('request.decline')))]),_c('div',{staticClass:"button approve",on:{"click":_vm.approve}},[_vm._v(_vm._s(_vm.$t('request.approve')))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }